import React from 'react';
import { FormikProps, getIn } from 'formik';
import TimeSelectRaw from '~/components/common/TimeSelect2';

interface TimeSelectProps {
  field: {
    name: string;
    value: any;
  };
  form: FormikProps<any>;
  disabled?: boolean;
  [key: string]: any;
}

const TimeSelect: React.FC<TimeSelectProps> = ({
  field,
  form,
  disabled = false,
  ...props
}) => (
  <TimeSelectRaw
    {...field}
    error={
      !!getIn(form.touched, field.name) && !!getIn(form.errors, field.name)
    }
    helperText={
      getIn(form.touched, field.name) && getIn(form.errors, field.name)
    }
    disabled={disabled || !!form.values.__readOnly}
    {...props}
  />
);

export default TimeSelect;
